@if (communityPosts() && communityPosts().length > 0) {
  <section class="community-summary">
    <div class="flex items-center justify-between mb-4 gap-4">
      <h3>What's popular in the Community this week?</h3>
      <ui-button
        class="flex-shrink-0"
        variant="tertiary"
        size="sm"
        [label]="communityCollapsed() ? 'Show posts' : 'Hide posts'"
        (onClick)="toggleCommunityCollapse(!communityCollapsed())" />
    </div>

    @if (!communityCollapsed()) {
      <div class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-4 items-stretch">
        @for (post of communityPosts(); track post.id) {
          <div
            class="community-card-grid border border-border-primary rounded-lg p-4 h-full cursor-pointer flex flex-col hover:bg-secondary-subtle"
            (click)="openCommunityPost(post)">
            <!-- Post title - max 2 lines -->
            <h4 class="font-semibold text-base mb-2 line-clamp-2">{{ post.title }}</h4>

            <div class="text-sm text-gray-600 mb-4 hidden lg:block leading-relaxed flex-1">
              <span class="line-clamp-2">{{ post.excerpt }}</span>
            </div>

            <!-- Footer: author + stats - always at bottom -->
            <div class="community-footer flex items-center justify-between sticky bottom-0">
              <div class="flex items-center gap-3 flex-1 min-w-0">
                @if (post.author?.avatar) {
                  <img [src]="post.author.avatar" class="rounded-full w-6 h-6 flex-shrink-0" />
                }

                <div class="flex items-center gap-1">
                  <ui-icon icon="griddy-thumbs-up" [size]="16" />
                  {{ post.stats?.likes || 0 }}
                </div>

                <div class="flex items-center gap-1">
                  <ui-icon icon="griddy-chat-bubble-text" [size]="16" />
                  {{ post.stats?.comments || 0 }}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </section>
}
